import { alpha, type Theme } from '@mui/material/styles'

/**
 * Offset of the logo drop-shadow, in px. The shadow is painted with CSS
 * `box-shadow`, which takes no layout space — so consumers that need the shadow
 * to occupy layout (e.g. so a flex `gap` starts from the shadow's outer edge,
 * not the logo's border) must reserve `.x`/`.y` as margin.
 */
export const LOGO_SHADOW_OFFSET = { x: 8, y: 6 } as const

/**
 * The offset drop-shadow used behind brand/merchant logo tiles across the
 * insights-v2 components (MerchantLogo, P2PLogoStack, …).
 *
 * Figma renders a solid 75%-opacity black shape offset to the bottom-right of
 * each logo tile; reproduced here as a single `boxShadow` (matches the shared
 * v1 `P2PMultipleCategorization`).
 */
export const getLogoShadow = (theme: Theme) =>
  `${LOGO_SHADOW_OFFSET.x}px ${LOGO_SHADOW_OFFSET.y}px 0 ${alpha(theme.palette.common.black, 0.75)}`

/**
 * The soft elevation shadow on the logo tiles in Monthly Subscription Aggregate
 * V2 (Figma `DROP_SHADOW` 0 / 2 / blur 8, black @ 0.12). Unlike `getLogoShadow`
 * this has no horizontal offset, so it stays within a padded row's edges.
 */
export const getLogoElevation = (theme: Theme) =>
  `0px 2px 8px 0px ${alpha(theme.palette.common.black, 0.12)}`
